// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"797626d2","338":"821c3efb","346":"7bd0df4c","473":"2aa54cb0","485":"8839c645","488":"065f81df","526":"62acab68","688":"e47b3b63","760":"b806d86e","773":"1cdcd82b","823":"30a1ff46"}[chunkId] + ".chunk.js";
};